import { Accordion2 as Accordion } from "@qgiv/core-donor";
import React, { useState } from "react";
import ConnectedRecurringSummaryHistoryDetails from "./RecurringSummaryHistoryDetails";

/**
 * @param {object} props
 * @param {string} props.accordionAdditionalText
 * @param {string} props.accordionLabel
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const RecurringSummaryHistory = ({
    accordionAdditionalText,
    accordionLabel,
    control,
}) => {
    // Adding the event key to the list of activeEventKeys in the instance of
    // React context used in this instance of the accordion expands the
    // accordion so that element of the Accordion.Collapse is visible
    const yourHistoryEventKey = 0;
    // Setting the list of activeEventKeys to an empty array ensures that the
    // accordion is collapsed on page load
    const collapsedAccordionEventKeys = [];
    const [activeEventKeys, setActiveEventKeys] = useState(
        collapsedAccordionEventKeys,
    );
    return (
        <div className="recurring-summary-history">
            {/* Accordion.Toggle */}
            <Accordion
                activeEventKeys={activeEventKeys}
                onToggle={setActiveEventKeys}
            >
                <div className="panel accordion__panel">
                    <Accordion.Toggle
                        eventKey={yourHistoryEventKey}
                        element={Accordion.Header}
                    >
                        <Accordion.HeaderReceiptContent
                            activeEventKeys={activeEventKeys}
                            eventKey={yourHistoryEventKey}
                            label={accordionLabel}
                            labelSubText={accordionAdditionalText}
                            displayPrintLink={false}
                        />
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={yourHistoryEventKey}>
                        <div className="-padding-bottom--20">
                            <div className="grid">
                                <ConnectedRecurringSummaryHistoryDetails
                                    control={control}
                                />
                            </div>
                        </div>
                    </Accordion.Collapse>
                </div>
            </Accordion>
        </div>
    );
};

export default RecurringSummaryHistory;
